import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SidebarContext } from "./SidebarContext";
import { fetchMe } from '../../slice/meSlice';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../slice/authSlice';
import { menus } from "./menus";

const Sidebar = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { me } = useSelector((state) => state.me);
    const permissions = me?.roles?.[0]?.permissions ?? [];

    const checkActiveLink = (paths) => {
        return paths.some(path => {
            const regexPath = path.replace(/:\w+/g, "[^/]+");
            const regex = new RegExp(`^${regexPath}$`);
            return regex.test(location.pathname);
        });
    };

    const { isOpen } = useContext(SidebarContext);
    const { toggleSidebar } = useContext(SidebarContext);

    useEffect(() => {
        dispatch(fetchMe()).unwrap();
    }, [dispatch]);

    // const menus = [
    //     { to: "/", body: ["/"], label: "Homepage", icon: "bi bi-house-door", type: 'Home', permission: "Homepage" },
    //     { to: "/claim-invoice", body: ["/claim-invoice"], label: "Claim Submission", icon: "bi bi-receipt-cutoff", type: 'Home', permission: "Claim Submission" },
    //     { to: "/user", label: "User", body: ["/user"], icon: "bi bi-person", type: 'Master Data', permission: "User" },
    //     { to: "/role-permission", body: ["/role-permission"], label: "Role Permission", icon: "bi bi-person-fill-lock", type: 'Master Data', permission: "Role Permission" },
    // ];

    return (
        <>
            <aside
                className={`sidebar ${isOpen ? 'open' : 'closed'}`}
                style={{
                    overflowY: "auto",
                    position: "fixed",
                    top: 0,
                    left: isOpen ? "0" : "-250px", // sembunyi di kiri kalau ditutup
                    height: "100%",
                    width: "250px",
                    backgroundColor: "#282c34",
                    color: "#fff",
                    transition: "left 0.3s ease-in-out",
                    zIndex: 1001,
                }}
                >
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ padding: "15px 20px" }}
                >
                    <div  style={{ fontSize: "14px", }} className="fw-semibold d-flex align-items-center mb-0"><img
                        src={`${process.env.PUBLIC_URL}/otobitz.png`}
                        alt="TOWASS AUTOMATION"
                        height="28"
                        className="me-2"
                    />TOWASS AUTOMATION</div>
                    <i
                    className="bi bi-x-lg fs-6 text-white d-md-none"
                    style={{ cursor: "pointer" }}
                    onClick={toggleSidebar} // tombol close muncul hanya di HP
                    ></i>
                </div>

                {(permissions ?? []).length <= 0 ? (
                    <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        marginLeft: "30px",
                        backgroundColor: "#444e59",
                        width: "75%",
                        height: "100%",
                        minHeight: "750px",
                        borderRadius: "10px",
                        animation: "blink 1s infinite",
                    }}
                    ></div>
                ) : (
                    <nav>
                    <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                        {[...new Set(
                        menus
                            .filter((menu) =>
                            permissions.some((perm) => perm.name === menu.permission)
                            )
                            .map((menu) => menu.type)
                        )].map((type, index) => (
                        <React.Fragment key={index}>
                            <li style={{ paddingLeft: "30px" }}>
                            <span
                                className="fw-semibold"
                                style={{ fontSize: "13px", color: "#1abc9c" }}
                            >
                                {type}
                            </span>
                            </li>

                            {menus
                            .filter(
                                (menu) =>
                                permissions.some(
                                    (perm) => perm.name === menu.permission
                                ) && menu.type === type
                            )
                            .map((menu, subIndex) => (
                                <li
                                key={subIndex}
                                style={{
                                    backgroundColor: checkActiveLink(menu.body)
                                    ? "rgba(255,255,255,0.1)"
                                    : "transparent",
                                    paddingLeft: "30px",
                                }}
                                className="py-2"
                                >
                                <Link
                                    to={menu.to}
                                    style={{
                                    fontSize: "14px",
                                    color: checkActiveLink(menu.body)
                                        ? "#1abc9c"
                                        : "#fff",
                                    textDecoration: "none",
                                    }}
                                    onClick={() => {
                                    if (window.innerWidth < 768) toggleSidebar(); // auto tutup di HP setelah klik menu
                                    }}
                                >
                                    <i className={`${menu.icon} me-2`}></i>
                                    {menu.label}
                                </Link>
                                </li>
                            ))}
                        </React.Fragment>
                        ))}
                    </ul>
                    </nav>
                )}
            </aside>


        </>
    );
}

export default Sidebar;